import { forwardRef, ReactNode } from 'react'

import { cn } from '@/ui/utils/style'

export interface TileButtonProps {
  children: ReactNode
  onClick: () => void
  isSelected: boolean
  className?: string
  'data-testid'?: string
}

export const TileButton = forwardRef<HTMLButtonElement, TileButtonProps>(
  ({ children, onClick, isSelected, 'data-testid': dataTestId, className }, ref) => {
    return (
      <button
        onClick={onClick}
        className={cn(
          'relative bg-primary',
          'rounded-sm p-2 outline-1 outline-primary outline-solid sm:p-4',
          'transition-all duration-200 hover:shadow-lg',
          'focus-visible:outline-0 focus-visible:ring-3 focus-visible:ring-primary-200 focus-visible:ring-offset-0',
          isSelected && 'bg-transparent outline-0',
          className,
        )}
        data-testid={dataTestId}
        ref={ref}
      >
        <div
          className={cn(
            'bg-[linear-gradient(white,white),linear-gradient(104.99deg,#FFC555_-21.89%,#FB4AB9_87.44%)]',
            '-z-10 absolute inset-0 rounded-sm border border-transparent bg-origin-border [background-clip:content-box,border-box]',
            !isSelected && 'hidden',
          )}
        />
        {children}
      </button>
    )
  },
)
TileButton.displayName = 'TileButton'
